import { createContext, useState, useMemo, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ToastMessageContext = /*#__PURE__*/createContext(null);

var ToastMessageContextProvider = function ToastMessageContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({
    message: '',
    visible: false,
    duration: 500,
    type: 'success',
    ui: 'simple'
  }),
      toastMessageOptions = _useState[0],
      setToastMessage = _useState[1];

  var toastMessageValue = useMemo(function () {
    return {
      toastMessageOptions: toastMessageOptions,
      setToastMessage: setToastMessage
    };
  }, [setToastMessage, toastMessageOptions]);
  return /*#__PURE__*/_jsx(ToastMessageContext.Provider, {
    value: toastMessageValue,
    children: children
  });
};

var useToastMessageContext = function useToastMessageContext() {
  var context = useContext(ToastMessageContext);
  if (!context) throw new Error('useToastMessageContext has to be used within <ToastMessageContext.Provider>');
  return useMemo(function () {
    return context;
  }, [context]);
};

export { ToastMessageContextProvider, useToastMessageContext };